import ReactSelect, { MultiValue, Props as ReactSelectProps } from 'react-select';

type StrongSelectOption = { label: string; value: string };

interface StrongSelectProps
    extends Omit<
        ReactSelectProps<StrongSelectOption, true>,
        'isMulti' | 'options' | 'value' | 'onChange'
    > {
    options: { label: string; value: string }[];
    value?: { label: string; value: string }[];
    onSelectChange?: (selected: string[]) => void;
}

const StrongSelect: React.FC<StrongSelectProps> = ({options, value, onSelectChange, ...props }) => {
    const handleChange = (selected: MultiValue<StrongSelectOption>) => {
        if (onSelectChange) {
            // Convert back to SectionTitle[] -> original format
            const transformed = selected ? selected.map(({value }) => (value)) : [];
            onSelectChange(transformed);
        }
    };
    return (
        <ReactSelect 
            isMulti
            options={options}
            value={value}
            onChange={handleChange}
            {...props}
        />
    );
};

export default StrongSelect;
